export const TRAINING_MODAL_NAME = 'training';
